// src/constants/HotjarEventNames.ts

export class HotjarEventNames {
  // Public taxi landing page experiment
  static TAXI_LANDING_PAGE_VIEWED = "taxi_landing_page_viewed";
  static TAXI_LANDING_GET_QUOTE_CLICKED = "taxi_landing_get_quote_clicked";
  static TAXI_LANDING_LOG_IN_CLICKED = "taxi_landing_log_in_clicked";
  static TAXI_LANDING_CONNECT_DIALOG_CLOSED =
    "taxi_landing_connect_dialog_closed";
  static TAXI_LANDING_CONNECT_VALIDATION_ERROR =
    "taxi_landing_connect_validation_error";
  static TAXI_LANDING_CONNECT_CONTINUE_CLICKED =
    "taxi_landing_connect_continue_clicked";

  // Login
  static PORTAL_LOGIN_REQUEST = "portal_login_request"; // Triggered before login API call
  static PORTAL_LOGIN_RESPONSE_NEW_CUSTOMER =
    "portal_login_response_NewCustomer"; // Triggered after successful login if user is new
  static PORTAL_LOGIN_RESPONSE_EXISTING_CUSTOMER =
    "portal_login_response_ExistingCustomer"; // Triggered after login if user is existing

  // Quote Landing
  static TAXI_QUOTE_START_LANDING = "taxi_quote_start_landing"; // User lands on the quote page

  // User Actions on Quote Page
  static TAXI_QUOTE_NEW_QUOTE_CLICKED = "taxi_quote_new_quote_clicked"; // User clicks on 'Get New Quote'

  // Multi-step form journey (Quote Stages)
  static TAXI_QUOTE_TQ1_ENTERED = "taxi_quote_tq1_entered";
  static TAXI_QUOTE_TQ1_NEXT_CLICKED = "taxi_quote_tq1_next_clicked";

  static TAXI_QUOTE_TQ2_ENTERED = "taxi_quote_tq2_entered";
  static TAXI_QUOTE_TQ2_NEXT_CLICKED = "taxi_quote_tq2_next_clicked";

  static TAXI_QUOTE_TQ3_ENTERED = "taxi_quote_tq3_entered";
  static TAXI_QUOTE_TQ3_NEXT_CLICKED = "taxi_quote_tq3_next_clicked";

  static TAXI_QUOTE_TQ4_ENTERED = "taxi_quote_tq4_entered";
  static TAXI_QUOTE_TQ4_NEXT_CLICKED = "taxi_quote_tq4_next_clicked";

  static TAXI_QUOTE_TQ5_ENTERED = "taxi_quote_tq5_entered";
  static TAXI_QUOTE_TQ5_NEXT_CLICKED = "taxi_quote_tq5_next_clicked";

  static TAXI_QUOTE_TQ6_ENTERED = "taxi_quote_tq6_entered";
  static TAXI_QUOTE_TQ6_NEXT_CLICKED = "taxi_quote_tq6_next_clicked";

  static TAXI_QUOTE_TQCLAIM_ENTERED = "taxi_quote_tqclaim_entered";
  static TAXI_QUOTE_TQCLAIM_NEXT_CLICKED = "taxi_quote_tqclaim_next_clicked";

  static TAXI_QUOTE_TQADDDRIVER_ENTERED = "taxi_quote_tqadddriver_entered";
  static TAXI_QUOTE_TQADDDRIVER_NEXT_CLICKED =
    "taxi_quote_tqadddriver_next_clicked";

  static TAXI_QUOTE_TQ_PANEL_ENTERED = "taxi_quote_tq_panel_entered";
  static TAXI_QUOTE_TQ_PANEL_SELECT_QUOTE_CLICKED =
    "taxi_quote_tq_panel_select_quote_clicked";

  // Multi-step form journey (Buy Stages)

  static TAXI_QUOTE_TBADDONRECOMMENDATIONNS_ENTERED =
    "taxi_quote_tbaddonrecommendationns_entered";
  static TAXI_QUOTE_TBADDONRECOMMENDATIONNS_NEXT_CLICKED =
    "taxi_quote_tbaddonrecommendationns_next_clicked";

  static TAXI_QUOTE_TBDOCUMENTS_ENTERED = "taxi_quote_tbdocuments_entered";
  static TAXI_QUOTE_TBDOCUMENTS_NEXT_CLICKED =
    "taxi_quote_tbdocuments_next_clicked";

  static TAXI_QUOTE_TBEPAYMENTS_ENTERED = "taxi_quote_tbepayments_entered";
  static TAXI_QUOTE_TBEPAYMENTS_NEXT_CLICKED =
    "taxi_quote_tbepayments_next_clicked";

  static TAXI_QUOTE_TBDIRECTDEBITDETAILS_ENTERED =
    "taxi_quote_tbdirectdebitdetails_entered";
  static TAXI_QUOTE_TBDIRECTDEBITDETAILS_NEXT_CLICKED =
    "taxi_quote_tbdirectdebitdetails_next_clicked";

  static TAXI_QUOTE_TBGLOBALPAYMENTSPAGE_ENTERED =
    "taxi_quote_tbglobalpaymentspage_entered";

  static TAXI_QUOTE_TBPAYMENTSUCCESS_ENTERED =
    "taxi_quote_tbpaymentsuccess_entered";

  // Error Pages

  static TAXI_ERROR_NO_ACCOUNT = "taxi_error_no_account";
  static TAXI_ERROR_ALMOST_THERE = "taxi_error_almost_there";
  static TAXI_ERROR_NO_QUOTE = "taxi_error_no_quote";
  static TAXI_ERROR_SERVER = "taxi_error_server";
}
